import styled from "@emotion/styled";
import { Chip } from "@material-ui/core";
// @ts-expect-error
import units from "design-units";

export const NDAChip = styled(Chip)`
  margin: 5px;
  height: auto;
  ${units({
    backgroundColor: "lightBlue",
  })};

  span {
    padding: 5px;
    font-size: 0.7rem;
  }
`;

export const NDAMarkers = styled.div`
  display: block;
  font-size: 0.95rem;
  margin: -3px 0 0;
`;

export const SelectedUserLabel = styled.h4`
  font-size: 1.1rem;
  margin: 0;
`;
